import React from "react";
import styled from "styled-components";
import { profiles } from "../../../modules/constants";
import { useTranslation } from "react-i18next";
import CardSeparator from "../CardSeparator/CardSeparator";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import PrimaryButton from "../Buttons/PrimaryButton/PrimaryButton";

const PageTitleWrapper = styled.div`
  width: 100%;
  padding: 20px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .user-info {
    margin-left: 2rem;
    display: flex;
    flex-direction: column;

    .first-line {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;

      div {
        display: flex;
        flex-direction: row;
      }
    }

    .second-line span {
      font-size: 14px;
    }

    button.user-config {
      font-weight: 600;
      font-size: 14px;
      border: 0px;
      margin-left: 10px;
      height: 33px;
      padding-left: 8px;
      padding-right: 8px;
    }
  }

  @media (max-width: 1200px) {
    padding: 20px;
    flex-direction: column;
    & > div {
      justify-content: space-between;
    }
    & > .study-info {
      margin-bottom: 1rem;
    }
    & > .user-info {
      margin-left: 0;

      .user-id {
        margin-right: auto;
      }

      justify-content: space-between;
    }
  }
`;

const Title = styled.h3`
  margin-right: 10px;
  @media (max-width: 460px) {
    font-size: 1.5rem;
  }
`;

const Subtitle = styled.p`
  line-height: 1.2;
  font-size: 1.75rem;
  font-weight: 600;
  color: ${(props) => props?.theme?.c7Silver};
  @media (max-width: 460px) {
    font-size: 0.9rem;
    display: flex;
    align-items: center;
  }
`;

const RoleName = styled.div`
  font-weight: 600;
  border-radius: 0.4rem;
  color: ${(props) => props?.theme?.black};
  background-color: ${(props) => props?.theme?.white};
  font-size: 14px;
  padding: 6px 15px;
  text-align: center;
  margin-left: 10px;
`;

const IdWrapper = styled.span`
  font-weight: 600;
  font-size: 30px;
  line-height: 30px;
  color: ${(props) => props?.theme?.nero};
  padding-right: 10px;
  direction: rtl;

  @media (max-width: 460px) {
    font-size: 18px;
  }
`;

const PageTitle = ({
  title,
  subtitle,
  roleName,
  id,
  setShowContactInfoModal,
  showContactInfo,
  participantUgnxId,
  site,
}) => {
  const { t } = useTranslation();

  return (
    <PageTitleWrapper data-testid="page-title-wrapper">
      <div className="study-info">
        <Title>
          {title}
          <CardSeparator style="-lg" />
        </Title>
        <Subtitle>{subtitle}</Subtitle>
      </div>
      <div className="user-info">
        <div className="first-line">
          {
            //Check if id which is fetched remotely already exists, if doesn't display loading.
            id ? (
              <>
                <IdWrapper className="user-id">{id}</IdWrapper>
                <div>
                  {roleName && (
                    <RoleName className="role">
                      {roleName === profiles.participant
                        ? t(`appText.participant`)
                        : roleName}
                    </RoleName>
                  )}
                  {site && <RoleName className="role">{site}</RoleName>}

                  {showContactInfo && (
                    <PrimaryButton
                      data-testid="user-config-btn"
                      className="user-config"
                      size="sm"
                      onClick={() => setShowContactInfoModal(true)}
                    >
                      <i className="fas fa-user-cog" />
                    </PrimaryButton>
                  )}
                </div>
              </>
            ) : (
              <LoadingSpinner />
            )
          }
        </div>
        {roleName !== profiles.participant && participantUgnxId && (
          <div className="second-line">
            <span>Viewing participant {participantUgnxId}</span>
          </div>
        )}
      </div>
    </PageTitleWrapper>
  );
};

export default PageTitle;
